import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_BILLS_TO_PAY,
  GET_BILLS_TO_PAY_BY_HASH,
  CREATE_BILLS_TO_PAY,
  UPDATE_BILLS_TO_PAY,
  DELETE_BILLS_TO_PAY,
} from './actionType';

// common success
export const BillsToPayApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const BillsToPayApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetBillsToPay = (period, status, type) => ({
  type: GET_BILLS_TO_PAY,
  payload: { period, status, type },
});

export const GetBillsToPayByHash = (hash) => ({
  type: GET_BILLS_TO_PAY_BY_HASH,
  payload: { hash },
});

export const CreateBillsToPay = (data) => ({
  type: CREATE_BILLS_TO_PAY,
  payload: { data },
});

export const UpdateBillsToPay = (hash, data) => ({
  type: UPDATE_BILLS_TO_PAY,
  payload: { hash, data },
});

export const DeleteBillsToPay = (hash) => ({
  type: DELETE_BILLS_TO_PAY,
  payload: { hash },
});
